import axios from 'axios'
import ErrorId from './errorId'
import ErrorMessage from './errorMessage'
import HttpStatusCodeMessage from './httpStatusCodeMessage'
import { app } from '@/main'

const baseAxios = axios.create({ baseURL: '' })

// 帶 token
baseAxios.interceptors.request.use((config) => {
  config.baseURL = process.env.VUE_APP_API_URL
  config.headers['Content-Type'] = 'application/json'

  // 有 token 才帶
  const token = localStorage.getItem('userToken')
  if (token) {
    config.headers.Authorization = token
  }

  const mergedHeaders = {
    ...config.headers,
    ...config?.additionalConfig?.headers
  }

  return {
    ...config,
    ...config?.additionalConfig,
    headers: mergedHeaders
  }
})

baseAxios.interceptors.response.use(
  function (res) {
    if (res.data && res.data.result && res.data.result !== ErrorId.SUCCESS) {
      let errorMessage = ErrorMessage.getMessage(res.data.result)
      console.error(errorMessage)
      // throw new Error(errorMessage)
      errorMessage &&
        app.messageBox({
          type: 'error',
          title: errorMessage,
          showCancelButton: false
        })
      return {
        ...res,
        errorMessage
      }
    } else {
      return res
    }
  },
  function (err) {
    if (err.response?.status) {
      let errorMessage = HttpStatusCodeMessage.getMessage(err.response?.status)
      app.messageBox({
        type: 'error',  
        title: errorMessage,
        showCancelButton: false
      })
    }
    throw err.response
  }
)

const baseFetch = async (url = '', method = 'get', params = {}, config) => {
  let response = {
    status: null,
    data: {}
  }

  // 重組回傳頁面資料格式
  const responseFormated = (res) => {
    return {
      isError: !(res.data && res.data.result == 'S0000'),
      status: res.status,
      data: res.data,
      errorMessage: res.errorMessage ? res.errorMessage : null
    }
  }

  switch (method) {
    case 'get':
      response = await baseAxios.get(url, {
        params,
        additionalConfig: config
      })
      return response.data ? responseFormated(response) : response
    case 'post':
      response = await baseAxios.post(url, params, { additionalConfig: config })
      return responseFormated(response)
    case 'put':
      response = await baseAxios.put(url, params, { additionalConfig: config })
      return responseFormated(response)
    case 'delete':
      response = await baseAxios.delete(url, { params })
      return responseFormated(response)
    default:
      console.error('method not found')
      return response
  }
}

export { baseFetch }
